import parsePhoneNumber from 'libphonenumber-js';

export const validatePhoneNumber = (phoneNumber) => {
  if (phoneNumber === '' || phoneNumber === null) {
    return false;
  }

  try {
    const number = parsePhoneNumber(phoneNumber);
    return number.isValid();
  } catch (error) {
    return false;
  }
};
